import * as React from 'react'
import { Form } from 'antd'
import { get, uniqBy } from 'lodash'
import { showError } from 'helpers/errors'
import { createSetFilterValue } from 'helpers/filters'
import { stopEvent } from 'helpers/events'
import { t } from 'helpers/i18n'
import chartTypes from 'options/dashboards/chartTypes'
import Select, { Option, OptGroup } from 'elements/Select'
import { Row, Col } from 'elements/Grid'

class Filter extends React.Component {
  state = {}

  constructor(props) {
    super(props)

    this.setFilterValue = createSetFilterValue(this)
  }

  async componentDidMount() {
    try {
      const responses = await Promise.all([this.props.getChartMetricTypes()])

      this.setState({ chartMetricTypes: get(responses[0], 'value.data.items', []) })
    } catch (error) {
      showError({ error })
    }
  }

  render() {
    const { filterDto = {} } = this.props
    const { chartMetricTypes = [] } = this.state

    const chartMetricCategoryTypes = uniqBy(
      chartMetricTypes.map(({ categoryType, categoryName }) => ({
        categoryType,
        categoryName,
      })),
      'categoryType',
    )

    return (
      <Form layout="vertical" colon={false} onSubmit={stopEvent}>
        <Row>
          <Col third>
            <Form.Item label={t('chartType')}>
              <Select
                onChange={(value) => this.setFilterValue('chartType', value)}
                value={filterDto.chartType}
                placeholder={t('all')}
                allowClear
              >
                {Object.entries(chartTypes).map(([key, value]) => (
                  <Option key={key} value={key}>
                    {t(value.languageKey)}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col third>
            <Form.Item label={t('metric')}>
              <Select
                value={filterDto.chartMetricType}
                onChange={(value) => this.setFilterValue('chartMetricType', value)}
                placeholder={t('all')}
                showSearch
                allowClear
              >
                {chartMetricCategoryTypes.map((category) => (
                  <OptGroup key={category.categoryType} label={category.categoryName}>
                    {chartMetricTypes
                      .filter((metric) => metric.categoryType === category.categoryType)
                      .map((metric) => (
                        <Option key={metric.type} value={metric.type}>
                          {metric.name}
                        </Option>
                      ))}
                  </OptGroup>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    )
  }
}

export default Form.create()(Filter)
